export default __webpack_public_path__ + "static/media/Matthew Mashava.04a560da.jpeg";